import { useIntegrationStatusSelectOptions } from "components/UI/Selects/IntegrationStatusSelectSearchable/useIntegrationStatusSelectOptions.ts";
import {
    SearchableSelect,
    SearchableSelectWrapperProps,
} from "components/UI/Selects/SearchableSelect/SearchableSelect.tsx";

export const IntegrationStatusSelectSearchable = (props: SearchableSelectWrapperProps) => {
    const hookResult = useIntegrationStatusSelectOptions();

    return (
        <SearchableSelect
            hookResult={hookResult}
            translationNamespace="forms.general-fields.status"
            {...props}
            size={props.size ?? "middle"}
        />
    );
};
